/**
 * @description
 *
 * Сериализация объекта в строку key1=value1&...&keyN=valueN
 *
 * @param {object} obj - объект для сериализации
 *
 * @returns {string} объект в виде строки -
 */

function serializeObject(obj) {
  return Object.entries(obj).map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join('&')
}

export default serializeObject
